import React from 'react';
import PropTypes from 'prop-types';
import { Paginator } from '@els/els-react--paginator';
import { PAGE_LIMIT } from '@Containers/PatentFamilyClustering/constants';
import { MetadataPropTypesShape } from '@Components/Results/MetadataPropTypes';

const MAX_PAGES_TO_SHOW = 5;

function PatentFamilyPagination({ document, metadata, groupCount, pageNumber, setPageNumber }) {
  return (
    <Paginator
      className="patent-family-pagination"
      onPageChange={(page) => {
        setPageNumber({ document, metadata, pageNumber: page });
      }}
      resultsPerPage={PAGE_LIMIT}
      totalResults={Number(groupCount)}
      currentPage={pageNumber}
      shouldShowFirstLastButton
      maxPagesToShow={MAX_PAGES_TO_SHOW}
      a11y={{ name: 'Paten family group pagination', pagingUnitName: 'Page', morePagingUnit: 'More pages' }}
    />
  );
}

PatentFamilyPagination.propTypes = {
  document: PropTypes.object.isRequired,
  metadata: MetadataPropTypesShape,
  groupCount: PropTypes.string,
  pageNumber: PropTypes.number.isRequired,
  setPageNumber: PropTypes.func.isRequired,
};

export default PatentFamilyPagination;
